"use client";

import { Smoothup } from "@/components/common/animations/Smoothup";
import { useAPYContext } from "@/features/apy/context/APYContext";
import type { MetricItem } from "@/data/pressContent";

interface PressMetricsSectionProps {
  headline: string;
  items: MetricItem[];
}

export default function PressMetricsSection({
  headline,
  items,
}: PressMetricsSectionProps) {
  const { apyRate } = useAPYContext();

  function resolveValue(value: string) {
    return apyRate ? value.replace("{apyRate}", apyRate) : value;
  }

  // Without a live rate, drop metrics that would show an empty APY
  const visibleItems = apyRate
    ? items
    : items.filter((item) => !item.value.includes("{apyRate}"));

  return (
    <section className="bg-[#FFFFF0] py-16 md:py-24">
      <div className="max-w-5xl mx-auto px-5 xl:px-0">
        <Smoothup>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12 text-center">
            {headline}
          </h2>
        </Smoothup>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-6 md:gap-8">
          {visibleItems.map((item, i) => (
            <Smoothup key={i} delay={i * 0.05}>
              <div className="bg-white rounded-xl p-6 text-center border border-gray-100 shadow-sm">
                <p className="text-3xl md:text-4xl font-bold text-gray-900">
                  {resolveValue(item.value)}
                </p>
                <p className="text-sm font-semibold text-gray-700 mt-2">
                  {item.label}
                </p>
                <p className="text-xs text-gray-400 mt-1">{item.context}</p>
              </div>
            </Smoothup>
          ))}
        </div>
      </div>
    </section>
  );
}
